"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const queryKeys = {
    formalReview: {
        activeCycles: (params) => (0, compact_1.default)(['formal-review', 'active-cycles', params]),
        peerSuggestions: (params) => (0, compact_1.default)(['formal-review', 'peer-review', 'suggestions', params]),
        peerHistory: (cycleId, targetId) => (0, compact_1.default)(['formal-review', 'peer-review', 'history', cycleId, targetId])
    }
};
exports.default = queryKeys;
